
import dateUtils from "@/utils/date";

export const pageMonCompteMaFideliteProps = () => ({
  fidelites: {
    type: Array,
    required: true
  },
  client: {
    type: Object,
    required: true
  },
  showWelcomeMessage: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const usePageMonCompteMaFidelite = (props) => {
  const malinCard = computed(() => {
    const malinCard = props.fidelites.find(card => card.attributes.type_carte === 'malin')
    if (malinCard) {
      return malinCard;
    }

    const tempCard = { attributes: { type_carte: 'malin' } }
    if (props.client.attributes.num_carte_malin) {
      tempCard.id = props.client.attributes.num_carte_malin;
      tempCard.attributes.expired = true;
    }
    return tempCard
  })
  const coraCard = computed(() => {
    const coraCard = props.fidelites.find(card => card.attributes.type_carte === 'cora')
    if (coraCard) {
      return coraCard;
    }
    const tempCard = { attributes: { type_carte: 'cora' } }
    if (props.client.attributes.num_carte_cora) {
      tempCard.id = props.client.attributes.num_carte_cora;
      tempCard.attributes.expired = true;
    }
    return tempCard
  })
  const hasNoCard = computed(() => {
    return !coraCard.value.id && !malinCard.value.id
  })

  const getTodayDate = () => {
    return dateUtils.getTodayDate()
  }

  return {
    malinCard,
    coraCard,
    hasNoCard,
    getTodayDate
  }
}